
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getProjectsList,
  getProjectByNumber,
} from "../../../common/services/uiService";

export const getProjectThunk = createAsyncThunk(
  "list/getProjectList",
  async (
    { endpoint, pageSize = 5, pageNumber = 1, searchString = "" },
    thunkAPI
  ) => {
    try {
      const response = await getProjectsList(
        endpoint,
        pageSize,
        pageNumber,
        searchString
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const getprojectByNumberThunk = createAsyncThunk(
  "list/getProjectByNumber",
  async ({ endpoint, projectNumber }, { rejectWithValue }) => {
    try {
      const data = await getProjectByNumber(endpoint, projectNumber);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || "Unknown error"
      );
    }
  }
);
